import React, { useEffect } from 'react'
import landing1 from '../../img/landing1.png'
import landing2 from '../../img/landing2.png'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faUserDoctor, faDog, faScissors } from '@fortawesome/free-solid-svg-icons'

const IndexLanding = ({ setSelectActionPublicZone }) => {

    useEffect(() => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    }, [])

    return (
        <>
            <div className="row m-0">
                <div className="col-12 col-sm-12 col-md-6 col-lg-6 p-0" >
                    <div className='div-container-landing'>
                        <h1 className='size-landing-h1'>
                            Gestiona tus citas de forma profesional, rápida y flexible.
                        </h1>
                        <h2 className='size-landing-h2'>
                            Una solución pensada para profesionales independientes e instituciones que ofrecen servicios de salud, belleza o veterinaria.
                        </h2>
                        <h2 className='size-landing-h2'>
                            Además, brinda a tus clientes una experiencia ágil y confiable para encontrar, agendar y gestionar sus citas con facilidad.
                        </h2>
                        <h2 className='size-landing-h2 p-bold'>
                            Más citas, más ventas. Más confianza, más clientes felices
                        </h2>
                    </div>
                </div>
                <div className="col-12 col-sm-12 col-md-6 col-lg-6 p-0" >
                    <div>
                        <img src={landing1} alt='landing1' className='img-landing-1'></img>
                    </div>
                </div>
            </div>
            <div className='div-container-landing background-landing'>
                <div className="row m-0">
                    <div className="col-12 col-sm-12 col-md-12 col-lg-12 p-0" >
                        <h1 className='size-landing-h1'>
                            Adaptada a tu tipo de negocio. Tú eliges cómo usarla.
                        </h1>
                    </div>
                </div>
                <br />
                <div className="row m-0">
                    <div className="col-12 col-sm-12 col-md-4 col-lg-4" >
                        <div className='div-target-landig-padre'>
                            <FontAwesomeIcon className='icon-users-total' icon={faUserDoctor} />
                            <div className='div-target-landig'>
                                <div>
                                    <p className='p-element-target-landing-1'>Salud, bienestar y cuidado personal </p>
                                    <p className='p-element-target-landing-2' >
                                        Para médicos, psicólogos, terapeutas, nutricionistas y más. Agenda tus pacientes sin complicaciones.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-12 col-sm-12 col-md-4 col-lg-4 mt-card-landing-dgc" >
                        <div className='div-target-landig-padre'>
                            <FontAwesomeIcon className='icon-users-total' icon={faScissors} />
                            <div className='div-target-landig'>
                                <div>
                                    <p className='p-element-target-landing-1'>Belleza, peluquería y cuidado estético</p>
                                    <p className='p-element-target-landing-2' >
                                        Ideal para salones, barberos, esteticistas y maquilladores. Organiza tus citas y evita el overbooking.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-12 col-sm-12 col-md-4 col-lg-4 mt-card-landing-dgc" >
                        <div className='div-target-landig-padre'>
                            <FontAwesomeIcon className='icon-users-total' icon={faDog} />
                            <div className='div-target-landig'>
                                <div>
                                    <p className='p-element-target-landing-1'> Clínicas y servicios veterinarios</p>
                                    <p className='p-element-target-landing-2' >
                                        Perfecta para veterinarias, groomers y especialistas en animales. Gestiona múltiples profesionales desde una sola cuenta.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className='div-landing-buttons mt-5-dgc '>
                    <button className='bottom-custom' onClick={() => setSelectActionPublicZone('REGISTRA_AGENDATE')} >
                        Regístrate
                    </button>
                </div>
            </div>
            <div className="row m-0">
                <div className="col-12 col-sm-12 col-md-6 col-lg-6 p-0" >
                    <div>
                        <img src={landing2} alt='landing1' className='img-landing-1'></img>
                    </div>
                </div>
                <div className="col-12 col-sm-12 col-md-6 col-lg-6 p-0" >
                    <div className='div-container-landing'>
                        <h1 className='size-landing-h1'>
                            Una solución que se adapta a tu forma de trabajar.
                        </h1>
                        <p className='p-element-target-landing-2 margin-15' >
                            <span className='p-bold'>Profesional independiente: </span>
                            Crea tu perfil, configura tu disponibilidad y empieza a recibir citas. Todo desde tu celular o computador.
                        </p>
                        <p className='p-element-target-landing-2 margin-15' >
                            <span className='p-bold'>Institución con múltiples agendas: </span>
                            Administra varios profesionales desde una sola cuenta. Ideal para IPS, clínicas, salones o centros de atención.
                        </p>
                    </div>

                </div>
            </div>
            <div className="row m-0">
                <div className="col-12 col-sm-2 col-md-3 col-lg-3 p-0" >
                    <div className='div-container-landing background-landing'></div>
                </div>
                <div className="col-12 col-sm-8 col-md-6 col-lg-6 p-0" >
                    <div className='div-container-landing background-landing'>
                        <h1 className='size-landing-h1'>
                            ¿Por qué elegirnos?
                        </h1>
                        <div className='div-beneficios-landing'>
                            <p className='p-element-target-landing-2 margin-15' >
                                📅 Agenda inteligente y personalizable
                            </p>
                            <p className='p-element-target-landing-2 margin-15' >
                                📲 Recordatorios automáticos por correo electrónico
                            </p>
                            <p className='p-element-target-landing-2 margin-15' >
                                🔐 Seguridad y privacidad de datos
                            </p>
                            <p className='p-element-target-landing-2 margin-15' >
                                🌐 Acceso desde cualquier dispositivo
                            </p>
                            <p className='p-element-target-landing-2 margin-15' >
                                🧩 Integración con tu flujo de trabajo
                            </p>
                        </div>
                        <div className='div-landing-buttons mt-3'>
                            <button className='bottom-custom' onClick={() => setSelectActionPublicZone('REGISTRA_AGENDATE')} >
                                Obten una demo
                            </button>
                        </div>
                    </div>
                </div>
                <div className="col-12 col-sm-2 col-md-3 col-lg-3 p-0" >
                    <div className='div-container-landing background-landing'></div>
                </div>
            </div>
        </>
    )
}

export default IndexLanding